

import { Component, OnInit, ViewChild } from '@angular/core';
import { NestedTableComponent } from '../nested-table/nested-table.component';
import { DashboardPageType } from 'globals/store/user.data';
import { TasksCommandMenu } from './tasks-command-menu.component';
import { workforceEventListReselector } from 'src/app/store/reselectors/events.reselector';
import { Wrapper } from '../wrapper.component';
import { TasksTableComponent } from './tasks-table.component';
import { JoiEvent } from 'globals/store/events.data';
import { sleepForMS } from '../../helpers/helpers';
import { HomeWrapperComponent } from '../nav-bar/home-wrapper.component';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { CalendarComponent } from 'src/app/modules/task-calendar/calendar.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'all-tasks',
    template: `
<home-wrapper *ngIf="viewMode === 'table' ? filterPageTypes.allTasks : filterPageTypes.allTasksCalendar as filterPage" [homeTab]="'TASKS'" [viewMode]="viewMode" (changeViewMode)="changeViewMode($event)">
  <loader-pane-fragment [trace]="traceNames.viewAllTasks"></loader-pane-fragment>
  <tasks-command-menu [filterPage]="filterPage" [outsideEvent]="true" [isCalendarView]="viewMode !== 'table'" [isTableView]="viewMode === 'table'" (saveTable)="saveTable()" ></tasks-command-menu>
  <tasks-table
    *ngIf="viewMode === 'table'"
    [saveType]="'all tasks'" 
    [saveName]="'All tasks table'" 
    [allTasks]="true"
    [initialized]="gettingTasks"
    [filterPage]="filterPage"
  ></tasks-table>
  <calendar *ngIf="viewMode === 'calendar'" (addDatedTask)="addDatedTask($event)" [filterPage]="filterPage"></calendar>
</home-wrapper>
  `,
    styleUrls: ['./all-tasks.scss'],
    standalone: true,
    imports: [HomeWrapperComponent, CommonModule, LoaderPaneFragmentComponent, TasksCommandMenu, TasksTableComponent, CalendarComponent],
})
export class AllTasksComponent extends Wrapper<AllTasksComponent> implements OnInit {
  viewMode: DashboardPageType = 'table'
  @ViewChild(TasksCommandMenu) taskCommandMenu: TasksCommandMenu
  @ViewChild(TasksTableComponent) taskTable: TasksTableComponent
  workforceEvents: JoiEvent[]
  gettingTasks = false
  traceNames = traceNames;

  saveTable(){
    this.taskTable.saveTable();
  }

  changeViewMode(viewMode: DashboardPageType) {
    this.viewMode = viewMode
  }

  addDatedTask(data: { dateId: string, event: Event }) {
    // console.log(data)
    const { dateId, event } = data
    this.taskCommandMenu.addTask(event, dateId)
  }

  ngOnInit() {
    this.selectProp(workforceEventListReselector, null, 'workforceEvents')
    this.waitAccountsAndEventsThenGetTasks()
  }

  async waitAccountsAndEventsThenGetTasks() { // this is so we don't have to get tasks for events on inactive accounts, and to make sure to load events when switching from in event directly to all tasks table
    await sleepForMS(100) // need time for iGotTheAccounts to reset
    // console.log({ gotAccounts: this.accountService._iGotTheAccounts, nEventQueries: this.eventService.event_queries_currently_loading })
    const limit = 50;
    let attempts = 0;
    while (!this.accountService._iGotTheAccounts || this.eventService.event_queries_currently_loading) {
      if (attempts >= limit) break;
      await sleepForMS(100)
      // console.log({ gotAccounts: this.accountService._iGotTheAccounts, nEventQueries: this.eventService.event_queries_currently_loading })
      attempts++
    }
    this.taskService.getTasksByEvents(this.workforceEvents)
    await sleepForMS(100)
    this.gettingTasks = true
  }




}

